import React from 'react';
import { $Breadcrumbs, $Link } from './styles';
import { SvgIcon } from '../SvgIcon';
export const Breadcrumbs = ({ crumbs }) => {
    return React.createElement($Breadcrumbs, { separator: React.createElement(SvgIcon, { name: 'chevron-right', color: 'primary' }), "aria-label": 'breadcrumb' }, crumbs.map((crumb, i) => React.createElement($Link, { key: crumb.id, last: i === (crumbs.length - 1), onClick: () => crumb.handleClick(crumb.id) }, crumb.text)));
};
